import { Check } from "lucide-react";

export const ChipGroup = ({ options, value, onChange, multi = false, testPrefix, label }) => {
  const selected = multi ? value : (value ? [value] : []);
  const toggle = (id) => {
    if (!multi) return onChange(id === value ? "" : id);
    onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  };
  return (
    <div className="flex flex-wrap gap-3" role="group" aria-label={label}>
      {options.map((o) => {
        const on = selected.includes(o.id);
        return (
          <button
            key={o.id}
            type="button"
            aria-pressed={on}
            onClick={() => toggle(o.id)}
            data-testid={`${testPrefix}-${o.id}`}
            data-selected={on ? "true" : "false"}
            className={`inline-flex items-center gap-2 border px-5 py-3 font-body text-sm transition-all duration-300 ${
              on
                ? "border-primary bg-primary/15 text-primary"
                : "border-border/60 text-foreground/75 hover:border-primary/60 hover:text-foreground"
            }`}
          >
            {on ? <Check size={13} strokeWidth={2.5} /> : null}
            {o.label}
          </button>
        );
      })}
    </div>
  );
};
